
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface ServiceFaqsProps {
  faqs: Array<{ question: string; answer: string }>;
  serviceName: string;
}

const ServiceFaqs = ({ faqs, serviceName }: ServiceFaqsProps) => {
  if (!faqs || faqs.length === 0) return null;

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-serif font-bold text-pkstone-900 mb-8 text-center">
            Frequently Asked Questions About {serviceName}
          </h2>
          
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`faq-${index}`}
                className="bg-pkstone-50 rounded-lg px-6 border-none"
              >
                <AccordionTrigger className="text-left font-medium text-pkstone-900 hover:text-pkgreen-700 py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-pkstone-600 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default ServiceFaqs;
